import React from 'react';
import AgentChat from './AgentChat';
import { AGENT_RUNTIME_ARN } from '../../constants';

const ToolRefinementAgentChat: React.FC = () => (
  <AgentChat
    agentRuntimeArn={AGENT_RUNTIME_ARN}
    title="Tool Refinement Agent"
    description="Ask about your tools, configurations, and refinement workflows"
    emptySubtitle="Ask about tools, configurations, or refinement workflows."
  />
);

export default ToolRefinementAgentChat;
